<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="拍卖倒计时提醒"
      :visible.sync="dialogVisibleTips"
      :append-to-body="true"
      custom-class="zhuxiaodialog"
      width="480px"
    >
      <div class="tipsautions">
        <p>
          {{ currentAutionsDetail.supplierCompanyName }}拍卖的{{
            currentAutionsDetail.totalQuantity
          }}{{ currentAutionsDetail.dataType === 6 ? "张" : "吨"
          }}{{ currentAutionsDetail.dataTypeShow }}
        </p>
        <p>
          距截拍已不足<span>5分钟 {{ endTimerStr }}</span>
        </p>
        <p>机不可失，请把握最后机会！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="fotterspan" type="primary" @click="handleCloseTips"
          >确 定</span
        >
        <el-button type="primary" @click="gotoPrice">去 出 价</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasShownThreeMinTip: false,
      dialogVisibleTips: false,
      auctionDetail: null,
      currentAutionsDetail: {},
      endTimerStr: "",
      currentAuctionEndTime: null,
      auctionStartTime: "", // 拍卖开始时间
      auctionEndTime: "", // 拍卖结束时间
      isOneHour: false, // 是否是一小时内开始
      bidding: 0, // 拍卖中
      updataTimer: [],
      updataDays: null,
      timer: null, // 定时器
      fiveTimer: null, // 5分钟倒计时定时器
    };
  },
  async created() {
    let CNZZ_ID = "1281338756";
    // 创建cnzz统计js
    const script = document.createElement("script");
    script.src = `https://s9.cnzz.com/z.js?id=${CNZZ_ID}&async=1`;
    script.language = "JavaScript";
    document.body.appendChild(script);

    this.hasShownThreeMinTip = sessionStorage.getItem("hasShownThreeMinTip");

    // 拍卖产品
    // 从store中获取拍卖详情
    await this.$store.dispatch("actions/fetchAuctionDetail");
    if (!this.$store.state.actions.auctionDetail) {
      // 为空时的处理，比如直接 return 或显示加载中
      return;
    }
    this.auctionDetail = this.$store.state.actions.auctionDetail;

    // 当前拍卖产品
    this.currentAutionsDetail = this.$store.state.actions.auctionDetail;
    // 当前拍卖产品-截止时间戳
    this.currentAuctionEndTime = this.endTime();
    this.getEndTimer();

    // 计算拍卖开始时间戳
    this.auctionStartTime = this.startTime();
    // 计算拍卖截止时间戳
    this.auctionEndTime = this.endTime();
    this.countDown();
    this.fivecoutDown();
    // 每秒更新一次倒计时
    this.timer = setInterval(this.countDown, 1000);
    this.fiveTimer = setInterval(this.fivecoutDown, 1000);
    // console.error(this.hasShownThreeMinTip, "ssss");
  },
  watch: {
    // 监听拍卖信息变化
    "$store.state.actions.auctionDetail"(msg) {
      if (msg) {
        // console.error("watch拍卖详情", msg);
        // 清除定时器
        if (this.timer) {
          clearInterval(this.timer);
          this.auctionDetail = this.$store.state.actions.auctionDetail;
          // 计算拍卖开始时间戳
          this.auctionStartTime = this.startTime();
          // 计算拍卖截止时间戳
          this.auctionEndTime = this.endTime();
          this.timer = setInterval(this.countDown, 1000);
        }
      }
    },
    "$store.state.actions.globalMessage"(msg) {
      // console.error(this.hasShownThreeMinTip, "jjjj");
      if (msg && !this.hasShownThreeMinTip) {
        // console.error("tishisiii", msg);
        this.dialogVisibleTips = true;
        this.$store.dispatch("actions/fetchGlobalMessage", null);
        sessionStorage.setItem("hasShownThreeMinTip", "true");
      }
    },
    $route: {
      handler() {
        setTimeout(() => {
          //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            // let refererUrl = "/";
            // 用于发送某个URL的PV统计请求，
            window._czc.push(["_trackPageview", contentUrl, ""]);
          }
        }, 300);
      },
      immediate: true, // 首次进入页面即执行
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getEndTimer() {
      const timestamp = this.auctionDetail.bidEndTime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      this.endTimerStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 全局距离结束5分钟倒计时提醒
    fivecoutDown() {
      if (!this.auctionDetail) return "";
      const now = new Date().getTime();
      const remaining = this.currentAuctionEndTime - now;
      // 添加拍卖进行中距离结束还有3分钟提示
      this.hasShownThreeMinTip = sessionStorage.getItem("hasShownThreeMinTip");
      if (
        remaining <= 5 * 60 * 1000 &&
        remaining > 0 &&
        !this.hasShownThreeMinTip
      ) {
        // 全局发布消息
        this.$store.dispatch("actions/fetchGlobalMessage", true);
      }
    },
    // 截止时间或倒计时显示
    /**
     * auctionStatus
     * 2:待开售
     * 3:报价中
     * 20:已截止关闭
     * 自定义：bidding:1(拍卖中):0(未开始):-1(已结束)
     */
    countDown() {
      if (!this.auctionDetail) return "";
      const now = new Date().getTime();
      // 计算距离拍卖开始的时间
      const timeUntilStart = this.auctionStartTime - now;
      const oneHour = 60 * 60 * 1000; // 1小时对应的毫秒数
      // 拍卖未开始
      if (now < this.auctionStartTime) {
        // 距离开始时间还剩不到1小时
        if (timeUntilStart <= oneHour && timeUntilStart > 0) {
          const hours = Math.floor(timeUntilStart / (1000 * 60 * 60));
          const minutes = Math.floor(
            (timeUntilStart % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((timeUntilStart % (1000 * 60)) / 1000);

          const countHours = hours.toString().padStart(2, "0");
          const countMinutes = minutes.toString().padStart(2, "0");
          const countSeconds = seconds.toString().padStart(2, "0");

          this.updataTimer = [countHours, countMinutes, countSeconds];
          this.bidding = 0; // 保持为未开始状态，但显示倒计时
          this.isOneHour = true;
        } else {
          const startDate = new Date(this.auctionStartTime);
          const year = startDate.getFullYear();
          const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
          const day = startDate.getDate().toString().padStart(2, "0");
          const hour = startDate.getHours().toString().padStart(2, "0");
          const str = `${year}-${month}-${day} ${hour}:00 开始拍卖`;
          this.updataTimer[0] = str;
          this.bidding = 0;
          this.isOneHour = false;
        }
        // 拍卖进行中
      } else if (now >= this.auctionStartTime && now < this.auctionEndTime) {
        const remaining = this.auctionEndTime - now;
        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor(remaining / (1000 * 60 * 60));
        const minutes = Math.floor(
          (remaining % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
        const countDays = days.toString().padStart(2, "0");
        const countHours = hours.toString().padStart(2, "0");
        const countMinutes = minutes.toString().padStart(2, "0");
        const countSeconds = seconds.toString().padStart(2, "0");
        this.updataDays = countDays;
        this.updataTimer = [countHours, countMinutes, countSeconds];
        this.bidding = 1;
      } else {
        this.updataTimer = ["拍卖已结束"];
        this.bidding = -1;
      }
      this.$store.dispatch("actions/fetchIsOneHour", this.isOneHour);
      this.$store.dispatch("actions/fetchBinding", this.bidding);
      this.$store.dispatch("actions/fetchUpdataTimer", this.updataTimer);
      this.$store.dispatch("actions/fetchUpdataDaysTimer", this.updataDays);
    },
    // 计算拍卖开始时间戳
    startTime() {
      if (!this.auctionDetail) return "";
      return this.auctionDetail.bidStartTime;
    },
    // 计算拍卖截止时间戳
    endTime() {
      if (!this.auctionDetail) return "";
      return this.auctionDetail.bidEndTime;
    },
    handleCloseTips() {
      this.dialogVisibleTips = false;
    },
    gotoPrice() {
      this.$router.push({ path: "/auctionDetail" });
      sessionStorage.setItem("hasShownThreeMinTip", "true");
      // 获取当前路由完整地址path
      const currentPath = this.$route.fullPath;
      if (currentPath === "/auctionDetail") {
        location.reload();
        this.dialogVisibleTips = false;
      }
      this.dialogVisibleTips = false;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tipsautions {
  padding-left: 14px;
  p {
    font-size: 14px;
    line-height: 24px;
    color: #41464f;
    font-weight: 400;
    span {
      color: #4aab3d;
    }
  }
}
</style>

<style lang="scss">
.fotterspan {
  font-size: 14px;
  color: #03102b;
  width: 76px;
  border-radius: 4px;
  display: inline-block;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border: 1px solid #e5e6eb;
  cursor: pointer;
  margin-right: 16px;
}
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.paimaidialog {
}
</style>
